// src/configs/permissions.ts
export const permissions = {
    VIEW_DASHBOARD: "VIEW_DASHBOARD",
    VIEW_CASES: "VIEW_CASES",
    VIEW_SHIPMENTS: "VIEW_SHIPMENTS",
    EDIT_USER_DETAILS: "EDIT_USER_DETAILS",
    ADD_NEW_ACCOUNT: "ADD_NEW_ACCOUNT",
    VIEW_BILLING: "VIEW_BILLING",
    VIEW_FEE_AUDITOR: "VIEW_FEE_AUDITOR",
    VIEW_REMOVAL_SHIPMENTS: "VIEW_REMOVAL_SHIPMENTS",
    VIEW_CASES_REIMBURSED: "VIEW_CASES_REIMBURSED",
    VIEW_ACCOUNTS: "VIEW_ACCOUNTS",
    VIEW_DASHBOARD_ACCOUNT: "VIEW_DASHBOARD_ACCOUNT",
    VIEW_CASE_VIEW_COLUMN: "VIEW_CASE_VIEW_COLUMN",
    UPLOAD_AMAZON_RECEIPTS: "UPLOAD_AMAZON_RECEIPTS",
} as const;

export type Permission =
    typeof permissions[keyof typeof permissions];